import React from 'react';

import useFieldChange from 'hooks/use-field-change';
import loc from 'sources/locale/loc';
import UsersApi from 'api/UsersApi';
import { TextField, BaseItemsList } from 'components/controls';
import styles from './AdminUsers.scss';
import AdminUsersList from './AdminUsersList';

function AdminUsers() {
  const {
    values: { name, email },
    handleFieldChange,
  } = useFieldChange({
    name: '',
    email: '',
  });

  return (
    <section className={styles.container}>
      <h1>{loc('users')}</h1>
      <div className={styles.filterContainer}>
        <TextField
          onChange={handleFieldChange.bind(null, 'name')}
          name="name"
          value={name}
          variant="standard"
          label={loc('filter-name')}
        />
        <TextField
          onChange={handleFieldChange.bind(null, 'email')}
          name="email"
          value={email}
          variant="standard"
          label={loc('filter-email')}
        />
      </div>
      <BaseItemsList
        countPerPage={18}
        params={{
          filter: {
            name,
            email,
          },
        }}
        ItemsListComponent={AdminUsersList}
        onGetList={UsersApi.getUsersForAdmin.bind(UsersApi)}
      />
    </section>
  );
}

export default AdminUsers;



// WEBPACK FOOTER //
// ./src/components/Admin/UsersList/AdminUsers.jsx